const dashboard = {
  admin_dashboard: '/',
  hrms_dashboard: '/dashboard/hrmsDashboard'
};

export default dashboard;
